import { Container, ContainerChat } from "./styles";
import ReactLoading from "react-loading";
import { CircularProgress } from "@mui/material";
const Loading = () => {
  return (
    <Container>
      {/* <ReactLoading
        type={"spin"}
        color={"#000"}
        height={"50px"}
        width={"50px"}
      /> */}
      <CircularProgress />
    </Container>
  );
};

export const LoadingChat = () => {
  return (
    <ContainerChat>
      <ReactLoading
        type={"bubbles"}
        color={"#0000008A"}
        height={"50px"}
        width={"50px"}
      />
    </ContainerChat>
  );
};

export default Loading;
